var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.444 22.275l-6.172-6.173 2.057-2.057 4.115 4.113 8.227-8.228 2.058 2.058-10.285 10.287z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30.222c-7.844 0-14.222-6.379-14.222-14.222 0-7.842 6.379-14.222 14.222-14.222s14.222 6.38 14.222 14.222c0 7.844-6.379 14.222-14.222 14.222zM16 0c-8.823 0-16 7.177-16 16s7.177 16 16 16c8.823 0 16-7.177 16-16s-7.177-16-16-16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon-check-circle.3e2587395748f401c9d3487db4ce4104.svg";
export { ForwardRef as ReactComponent };